var map = {
	"./bg-BG.json": 792,
	"./ca-ES.json": 793,
	"./cs-CZ.json": 794,
	"./de-DE.json": 795,
	"./el-GR.json": 796,
	"./en-US.json": 358,
	"./es-ES.json": 797,
	"./et-EE.json": 798,
	"./fi-FI.json": 799,
	"./fr-FR.json": 800,
	"./he-IL.json": 801,
	"./it-IT.json": 802,
	"./ja-JP.json": 803,
	"./ko-KR.json": 804,
	"./nb-NO.json": 805,
	"./nl-NL.json": 806,
	"./nn-NO.json": 807,
	"./pl-PL.json": 808,
	"./pt-BR.json": 809,
	"./ro-RO.json": 810,
	"./ru-RU.json": 811,
	"./sk-SK.json": 812,
	"./sv-SE.json": 813,
	"./tr-TR.json": 814,
	"./zh-CN.json": 815
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 791;